<template>
  <div>

  <b-input-group prepend="City" class="mt-3">
    <b-form-input list="city-list" v-model="city" v-on:input="inputChange($event)"  autocomplete="off" placeholder="Enter city..."></b-form-input>
    <b-input-group-append>
      <b-button v-show="showGo" v-on:click.stop="fetchWeather(city)" variant="outline-info">Go</b-button>
    </b-input-group-append>
  </b-input-group>
  
  <datalist v-if="inputChars>2" id="city-list">
    <option v-for="item in cityList" :key="item.id">{{ item.city }}</option>
  </datalist> 

  <div id="report" class="border pt-2 mt-3" v-if="result">
  <ul style="list-style-type:none">
    <li> <b> Today at {{ weatherDate(result.dt) | moment("h:mm a") }} </b> </li>
    <span style="font-size:2em;font-weight:bolder;">  <b-img :src=weatherIcon(result.weather[0].icon)></b-img> {{ Math.round(result.main.temp) }} &#8451; </span> 
    <li> </li>
    <li> {{ Math.round(result.main.temp) }} &#8451; with {{ result.weather[0].description }} </li>
    <li> {{ windDescription() }}  </li>
  </ul>
  </div> 
   <div class="p-3">
    <div class="float-left" v-if="result && isToday()"><b-button variant="info" v-b-tooltip.hover title="Record this weather report in journal" class=" mt-2 ml-2" @click="apply"> Apply </b-button></div>
    <div class="float-right"><b-button v-if="result" class="mt-2 ml-2" @click="$emit('exit')"> Close </b-button></div>
   </div>  
  </div>
</template>

<script>
import MY_JSON from '@/json/city_list.json'
export default {
  name: "Weather",
  components: {
  },
  props: [
    'projectId',
    'date'
  ],
  data: function() {
    return {
        city: '',
        result: undefined,
        loading: true,
        errored: false,
        error: '',
        inputChars: 0,
        showGo: false,
        cityList: MY_JSON
    }
  },
  mounted: function() {
    this.city = localStorage.getItem(this.projectId);
    if (this.city) {
      this.fetchWeather(this.city);
    }
    
  },
 
  methods: {
      fetchWeather(city){
        this.result = undefined;
        var loc = city + ', ca';
        this.$http
        .get("weather?q="+ loc +"&units=metric&APPID=c38ac35822e6df0a5499e751d907b94f",
        {baseURL: "https://api.openweathermap.org/data/2.5/"})
        .then(response => {
          this.result = response.data;
          this.error = false;
          this.error = "";
          localStorage.setItem(this.projectId, this.city);
        })
        .catch(error => {
          this.errored = true;
          this.error = error.response.statusText;
        })
        .finally(() => (this.loading = false));    
      },
      inputChange(e){
        this.inputChars = e.length;
        this.showGo = true;
      },
      isToday(){
        var today = this.$moment().format("YYYYMMDD"); 
        if (this.date == today)  {
          return true;
        }
        else {
          return false;
        }
      },
      weatherIcon(icon){
      return "https://openweathermap.org/img/wn/" + icon + "@2x.png"
    },
      windDirection(deg) {
        var sector = ["N","NE","E","SE","S","SW","W","NW","N"];
        var val = Math.floor((deg/45)+.5);
        return sector[(val % 8)];
      },
      windDescription() {
        var direction = "";
        if (this.windDirection(this.result.wind.deg)){
          direction = this.windDirection(this.result.wind.deg);
        };
        return "Wind " + direction + " at " + Math.round(this.result.wind.speed  * 3.6) + " km/h"
      },
      weatherDescription() {
        return "" +  Math.round(this.result.main.temp) + "°C with " + this.result.weather[0].description
      },
      weatherDate(dt) {
        var dte = new Date(dt*1000);
        return dte;
      }, 
      apply() {
        //var time = "Today at " + this.weatherDate(this.result.dt).toLocaleTimeString('en-US',{timeStyle:'short', hour: 'numeric', minute: '2-digit'});
        var time = "Today at " + this.weatherDate(this.result.dt).toLocaleTimeString([],{hour: 'numeric', minute: '2-digit'});
        var temp = Math.round(this.result.main.temp);
        var general = this.result.weather[0].main;
        var desc = this.weatherDescription();
        var wind = this.windDescription();
        var oWeather = {time:time, general:general, temp:temp, desc:desc, wind:wind};
        this.$emit('apply', oWeather);
      }
  }
}

</script>

<style>

</style>